import { z } from 'zod';
// WhatsApp template component types
export const TemplateComponentTypeSchema = z.enum([
    'HEADER',
    'BODY',
    'FOOTER',
    'BUTTONS',
]);
// WhatsApp template component format (for headers)
export const TemplateComponentFormatSchema = z.enum([
    'TEXT',
    'IMAGE',
    'VIDEO',
    'DOCUMENT',
]);
// WhatsApp template status
export const TemplateStatusSchema = z.enum([
    'APPROVED',
    'PENDING',
    'REJECTED',
    'DISABLED',
]);
// WhatsApp template category
export const TemplateCategorySchema = z.enum([
    'ACCOUNT_UPDATE',
    'ALERT_UPDATE',
    'APPOINTMENT_UPDATE',
    'AUTO_REPLY',
    'ISSUE_RESOLUTION',
    'PAYMENT_UPDATE',
    'PERSONAL_FINANCE_UPDATE',
    'RESERVATION_UPDATE',
    'SHIPPING_UPDATE',
    'TICKET_UPDATE',
    'TRANSPORTATION_UPDATE',
    'MARKETING',
    'UTILITY',
    'AUTHENTICATION',
]);
// WhatsApp template component schema
export const TemplateComponentSchema = z.object({
    type: TemplateComponentTypeSchema,
    format: TemplateComponentFormatSchema.optional(),
    text: z.string().optional(),
    example: z.object({
        header_text: z.array(z.string()).optional(),
        body_text: z.array(z.array(z.string())).optional(),
    }).optional(),
});
// WhatsApp template schema
export const WhatsAppTemplateSchema = z.object({
    id: z.string(),
    name: z.string(),
    components: z.array(TemplateComponentSchema),
    language: z.string(),
    status: TemplateStatusSchema,
    category: TemplateCategorySchema,
});
// API response for fetching templates
export const WhatsAppTemplatesResponseSchema = z.object({
    data: z.array(WhatsAppTemplateSchema),
    paging: z.object({
        cursors: z.object({
            before: z.string().optional(),
            after: z.string().optional(),
        }).optional(),
    }).optional(),
});
// Edge function response for fetching templates
export const GetWhatsAppTemplatesResponseSchema = z.object({
    templates: z.array(WhatsAppTemplateSchema),
});
